import React from 'react';

export default class TicketStubCell extends React.Component {
  static propTypes = {
    header: React.PropTypes.string,
    text: React.PropTypes.string,
    isDisabled: React.PropTypes.bool
  };

  render () {
    const headerClass = this.props.isDisabled
    ? 'ticket_stub_cell__header is-disabled' : 'ticket_stub_cell__header';

    const textClass = this.props.isDisabled
    ? 'ticket_stub_cell__text is-disabled' : 'ticket_stub_cell__text';

    return (
      <div className="ticket_stub_cell">
        <div data-component="ticket-cell-label" className={headerClass}>{this.props.header}</div>
        <div data-component="ticket-cell-content" className={textClass}>{this.props.text}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/cell.js